var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-page find-driver-page"},[(!_vm.isLoading)?[_c('AppPageHeader',{attrs:{"page-title":"Найти водителя"}}),_c('div',{staticClass:"app-page__content"},[_c('div',{staticClass:"app-layout"},[_c('FindDriverIntro')],1)])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }